import { Link } from "react-router-dom";
import { useEffect } from "react";
import BookButton from "@/components/site/BookButton";

export default function NotFound() {
    useEffect(() => {
        document.title = "Not Found | 90 Day Alpha";
    }, []);
    return (
        <div
            data-testid="not-found-page"
            className="min-h-[80vh] flex items-center justify-center bg-[#020617] px-6"
        >
            <div className="text-center max-w-xl">
                <p className="font-display font-black text-[#D4AF37] text-7xl md:text-9xl tracking-tighter">
                    404
                </p>
                <h1 className="mt-4 font-display font-bold text-white text-3xl md:text-4xl">
                    This path doesn’t exist.
                </h1>
                <p className="mt-4 text-white/70">
                    But the path forward does. Start by booking a free
                    consultation.
                </p>
                <div className="mt-8 flex items-center justify-center gap-4">
                    <BookButton testId="404-book" label="Book Consultation" />
                    <Link
                        to="/"
                        data-testid="404-home"
                        className="text-white/70 hover:text-[#D4AF37] uppercase text-xs tracking-[0.2em] font-semibold"
                    >
                        ← Back Home
                    </Link>
                </div>
            </div>
        </div>
    );
}
